import { ResultOf } from "gql.tada";
import { StillWatchingDescriptionFillSectionById } from "@queries/entries/StillWatchingDescriptionFillSectionById";
import { AnimatedSplitLines } from "@components/shared/AnimatedSplitLines";
import { richTextToPlainText } from "@utils/richTextToPlainText";
import { useRef } from "react";
import { useScroll, useTransform } from "motion/react";
import { MarkdownLite } from "@components/shared/MarkdownLite";

export const StillWatchingDescriptionFillSection = ({
  entry: { descriptionFillSection: entry },
}: {
  entry: ResultOf<typeof StillWatchingDescriptionFillSectionById>;
}) => {
  const sectionRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start end", "end start"],
  });
  const value = useTransform(scrollYProgress, [0, 0.3, 0.8], [-1, -0.5, 0]);

  if (!entry) return null;

  return (
    <div className="flex dsk:flex-row flex-col py-36" ref={sectionRef}>
      <div className="grid-container">
        <h1 className="text-brand-cream dsk:col-start-2 dsk:col-span-5 col-span-full dsk:mb-0 mb-10 text-[1.5rem]">
          <MarkdownLite>{entry.title}</MarkdownLite>
        </h1>
        <div className="dsk:col-start-7 col-span-full text-current">
          <p className="text-body-feature">
            <AnimatedSplitLines
              value={value}
              animationType="clipPathReveal"
              underlyingTextClassNames="opacity-30"
            >
              {richTextToPlainText(entry.descriptionRichText?.json)}
            </AnimatedSplitLines>
          </p>
        </div>
      </div>
    </div>
  );
};
